import Swal from 'sweetalert2';

window.Swal = Swal;
window.swal = Swal;
window.sweetAlert = Swal;
window.Sweetalert2 = Swal;

globalThis.Swal = Swal;
globalThis.swal = Swal;
globalThis.sweetAlert = Swal;
globalThis.Sweetalert2 = Swal;
